import { Paper, Text, ScrollArea, Tree, Group } from '@mantine/core';
import { IconFolder, IconFolderOpen } from '@tabler/icons-react';
import { useFileExplorerContext } from './FileExplorerContext';

export function TreeNav() {
  const { tree, folderTreeData, selectedFolder, searchQuery, setSelectedFolder, setSearchQuery } =
    useFileExplorerContext();

  return (
    <Paper
      withBorder
      p="xs"
      radius="md"
      style={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}
    >
      <Text size="xs" fw={600} c="dimmed" mb="xs">
        資料夾結構
      </Text>
      <ScrollArea style={{ flex: 1, minHeight: 0 }} offsetScrollbars>
        <Tree
          tree={tree}
          data={folderTreeData}
          renderNode={({ node, expanded, hasChildren, elementProps }) => {
            const isSelected = selectedFolder === node.value && !searchQuery;
            return (
              <Group
                gap={6}
                {...elementProps}
                onClick={(e) => {
                  elementProps.onClick?.(e);
                  setSelectedFolder(node.value);
                  setSearchQuery('');
                }}
                style={{
                  padding: '5px 8px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  background: isSelected ? 'var(--mantine-color-blue-light)' : 'transparent',
                  color: isSelected ? 'var(--mantine-color-blue-9)' : 'inherit',
                }}
              >
                {hasChildren ? (
                  expanded ? (
                    <IconFolderOpen size={16} color="var(--mantine-color-blue-6)" />
                  ) : (
                    <IconFolder size={16} color="var(--mantine-color-blue-6)" />
                  )
                ) : (
                  <IconFolder size={16} color="var(--mantine-color-gray-6)" />
                )}
                <Text size="xs" fw={isSelected ? 600 : 400}>
                  {node.label}
                </Text>
              </Group>
            );
          }}
        />
      </ScrollArea>
    </Paper>
  );
}
